import React, { useEffect, useState } from 'react';
import ThemeEditor, { getPropStyle } from 'components/ThemeEditor/ThemeEditor';
import { colors } from './originals';
import ModelType from 'components/Model/ModelType';
import _ from 'lodash';

const convertPxToRem = (value) => {
  if (value.endsWith('px')) {
    const px = parseInt(value.replace('px', ''), 10);
    return px / 16.0 + 'rem';
  }
  return value;
};

const ThemeProperties = [
  {
    property: 'style.nav-item.background-color',
    type: ModelType.COLOR,
    defaultValue: () => {
      const root = getComputedStyle(document.documentElement);
      return root.getPropertyValue('--pf-v5-global--BackgroundColor--dark-100');
    },
    locations: [
      {
        where: 'navigator-background',
        label: 'Navigator background'
      }
    ]
  },
  {
    property: 'style.main-sidebar.background-color',
    type: ModelType.COLOR,
    defaultValue: () => {
      const root = getComputedStyle(document.documentElement);
      return root.getPropertyValue('--pf-v5-global--BackgroundColor--dark-100');
    },
    locations: [
      {
        where: 'sidebar',
        label: 'Sidebar background'
      }
    ]
  },
  {
    property: 'style.user-drawer-form.background-color',
    type: ModelType.COLOR,
    defaultValue: () => {
      const root = getComputedStyle(document.documentElement);
      return root.getPropertyValue('--pf-v5-global--BackgroundColor--dark-100');
    },
    locations: [
      {
        where: 'user drawer',
        label: 'User drawer background'
      }
    ]
  },
  {
    property: 'style.brand-img.padding',
    type: ModelType.TEXT,
    defaultValue: () => {
      return null;
    },
    locations: [
      {
        where: 'brand image padding',
        label: 'Brand image padding'
      }
    ]
  },
  {
    property: 'style.brand-img.margin',
    type: ModelType.TEXT,
    defaultValue: () => {
      const root = getComputedStyle(document.documentElement);
      return '' + root.getPropertyValue('--pf-v5-global--spacer--xs') + ' 0rem ' + root.getPropertyValue('--pf-v5-global--spacer--lg');
    },
    locations: [
      {
        where: 'brand image margin',
        label: 'Brand image margin'
      }
    ]
  }
];

const fullTheme = [...ThemeProperties,
  ..._.reduce(colors, (result, value, property) => {
    result.push({
      property: property,
      type: ModelType.COLOR,
      defaultValue: value,
      locations: [
        {
          where: 'Global color',
          label: property.replace('--pf-v5-global--', '').replace(/-/g, ' ')
        }
      ]
    });
    return result;
  }, [])
];


const rgb2hex = (rgb) => `#${rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/).slice(1).map(n => parseInt(n, 10).toString(16).padStart(2, '0')).join('')}`;

const convertValueFromType = (type, value) => {
  switch (type) {
    case ModelType.COLOR:
      return rgb2hex(value);
    default:
      return _.map(value?.split(' '), convertPxToRem).join(' ');
  }
};

const getAllProperties = (themeProperties) => {
  const root = getComputedStyle(document.documentElement);

  return _.map(themeProperties, (model) => {
    const props = getPropStyle(model);
    if (props.selector) {
      const element = document.querySelector(props.selector);
      if (element) {
        const computedStyle = getComputedStyle(element);
        if (computedStyle.getPropertyValue(props.property)) {
          let value = convertValueFromType(model.type, computedStyle.getPropertyValue(props.property));
          if (value === '0px') {
            value = null;
          }
          return {
            ...model,
            value
          };
        }
        return model;
      }
      console.error('No element found for selector:', props.property);
    } else {
      return {
        ...model,
        value: root.getPropertyValue(model.property)
      };
    }
  }, []);
};

const AdminThemeEditorPage = () => {
  const [theme, setTheme] = useState([]);
  useEffect(() => {
    const newTheme = getAllProperties(fullTheme);
    setTheme(newTheme);
  }, []);

  return (
    <div style={{ overflow: 'auto', height: '100%' }}>
      { !_.isEmpty(theme) && <ThemeEditor themeProperties={theme}/> }
    </div>
  );
};

export default AdminThemeEditorPage;
